import { Button, ButtonVariant, ButtonSize } from "shared/components";
import { FC } from "react";
import { PropertyGroupStep } from "../types";
import { HugeiconsIcon } from "@hugeicons/react";
import { InformationCircleIcon } from "@hugeicons-pro/core-solid-rounded";
import { useSpotlightContext } from "../providers/SpotlightProvider";

interface LayoutFooterProps {
  handleNextStep: () => void;
  handlePreviousStep?: () => void;
  currentStep: PropertyGroupStep;
  isContinueButtonDisabled: boolean;
  isButtonLoading: boolean;
}

export const LayoutFooter: FC<LayoutFooterProps> = ({
  handleNextStep,
  handlePreviousStep,
  currentStep,
  isContinueButtonDisabled,
  isButtonLoading
}) => {
  const { destroyAllDrivers } = useSpotlightContext();

  return (
    <div className="flex items-center justify-between gap-4">
      {![
        PropertyGroupStep.CONFIRM_GROUPS,
        PropertyGroupStep.INITIAL_CONFIGURATION
      ].includes(currentStep) ? (
        <div className="flex gap-2 items-center">
          <HugeiconsIcon
            icon={InformationCircleIcon}
            color="var(--primary-500)"
          />
          <p className="text-base text-content-1000 ">
            Press{" "}
            <span className="font-bold text-content-1000">
              &ldquo;Continue&rdquo;
            </span>{" "}
            when you are finished
          </p>
        </div>
      ) : null}

      <div className="flex gap-2 ml-auto" id="footer-buttons-property-groups">
        <Button
          variant={ButtonVariant.BASE}
          size={ButtonSize.BASE}
          className="w-[125px]"
          onClick={() => {
            destroyAllDrivers();

            handlePreviousStep?.();
          }}
        >
          {currentStep === PropertyGroupStep.INITIAL_CONFIGURATION
            ? "Cancel"
            : "Back"}
        </Button>
        <Button
          variant={ButtonVariant.PRIMARY}
          size={ButtonSize.BASE}
          className="w-[125px]"
          onClick={() => {
            destroyAllDrivers();

            handleNextStep();
          }}
          disabled={isContinueButtonDisabled || isButtonLoading}
          loading={isButtonLoading}
          id={
            currentStep === PropertyGroupStep.CONFIRM_GROUPS
              ? "confirm-property-groups"
              : "continue-property-groups"
          }
        >
          {currentStep === PropertyGroupStep.CONFIRM_GROUPS
            ? "Confirm"
            : "Continue"}
        </Button>
      </div>
    </div>
  );
};
